import { z } from "zod";

import { gradientPositions } from "@jti/ui/components/HeroV2/types/HeroV2Types";

export const LoyaltyHeroV2CtaTypeSchema = z.object({
  additionalBehavior: z.union([
    z.literal(null),
    z.enum(["onlyForRestrictedUsers", "onlyForLoggedIn", "onlyForNotLoggedIn", "always"]),
  ]),
  link: z.string(),
  label: z.string(),
  theme: z.enum(["light", "dark"]),
  layout: z.enum(["chevron", "full", "border"]),
  tracking: z.string(),
  target: z.enum(["_blank", ""]),
  openIn: z.enum(["new Tab", "same Tab"]).optional(),
});

const ContentBase = z.object({
  title: z.string(),
  tagLine: z.string().optional(),
  titleLogged: z.string().optional(),
  subheadline: z.string().optional(),
  subheadlineLogged: z.string().optional(),
  text: z.string().optional(),
  textLogged: z.string().optional(),
  cta: z.array(LoyaltyHeroV2CtaTypeSchema),
});

const ContentUnrestricted = ContentBase.extend({
  restrictedContent: z.literal(false).optional(),
  restrictedTitle: z.string().optional(),
  restrictedText: z.string().optional(),
});

const ContentRestricted = ContentBase.extend({
  restrictedContent: z.literal(true),
  restrictedTitle: z.string(),
  restrictedText: z.string(),
});

const ContentSchema = z.discriminatedUnion("restrictedContent", [ContentRestricted, ContentUnrestricted]);

const LoyaltyHeroBaseSchema = z.object({
  clipped: z.boolean(),
  logo: z.string().optional(),
  logoAlt: z.string().optional(),
  logoWidth: z.number().optional(),
  logoHeight: z.number().optional(),
  content: ContentSchema,
  displayScrollBar: z.boolean(),
  legalDisclaimer: z.string().optional(),
  logoReference: z.string().optional(),
  mobileVariant: z.enum(["transparentContentOnTop", "contentAtTheBottomWithBackground"]),
  gradientPosition: z.enum(gradientPositions).optional(),
  gradientPositionTablet: z.enum(gradientPositions).optional(),
  gradientPositionMobile: z.enum(gradientPositions).optional(),
  removeVideoRoundedCorners: z.boolean().optional(),
  theme: z.enum(["light", "dark", "inherit"]).optional(),
});

const ImageSchema = z.object({
  src: z.string(),
  alt: z.string(),
  title: z.string(),
});

const OptionalImageSchema = z.object({
  src: z.string().optional(),
  alt: z.string().optional(),
  title: z.string().optional(),
});

const LoyaltyHeroWithImageSchema = LoyaltyHeroBaseSchema.merge(
  z.object({
    backgroundType: z.literal("image"),
    desktopImage: ImageSchema,
    mediumImage: OptionalImageSchema.optional(),
    smallImage: ImageSchema,
  })
);

const LoyaltyHeroWithVideoSchema = LoyaltyHeroBaseSchema.merge(
  z.object({
    backgroundType: z.literal("video"),
    videoFileReference: z.string(),
    videoFileType: z.string().optional(),
    tabletVideoFileReference: z.string(),
    tabletVideoFileType: z.string().optional(),
    mobileVideoFileReference: z.string(),
    mobileVideoFileType: z.string().optional(),
  })
);

export const LoyaltyHeroDataSchema = z.discriminatedUnion("backgroundType", [
  LoyaltyHeroWithImageSchema,
  LoyaltyHeroWithVideoSchema,
]);
